const VALIDATION_ERROR_MESSAGES = {
  invalidEmail: 'Please enter a valid email ID',
  invalidPassword: 'Please enter a valid password',
  invalidAccountNumber: 'Please enter valid account number',
  accountNumberRequired: 'Please enter account number',
  invalidLandlineNumber: 'Please enter valid last 4 digits mobile/landline number',
  landlineNumberRequired: 'Please enter last 4 digits mobile/landline number',
};
const API_VALIDATION_ERROR_MESSAGES = {
  invalidRecaptcha: 'Invalid reCAPTCHA!',
  ivalidCredentials: 'Invalid credentials!',
  ivalidAccountData: 'TeleNo not found',
  accountNotFound: 'Account not found',
  mobileOnlyCustomer: 'No broadband subscription',
  invalidLogin: 'Your email or password may be incorrect',
  invalidAccount: 'Your account number or last four digits you have provided may be incorrect',
  genericError: 'Something went wrong, please try again later',
};

export { VALIDATION_ERROR_MESSAGES, API_VALIDATION_ERROR_MESSAGES };
